import JengaMockup1 from '../Welcome/jenga-realty.png';
import JengaMockup2 from '../Welcome/jenga-realty-2.png';
import mobilePlaceholder from './mobile.jpg';

export const caseStudies = [
  {
    id: "jenga-realty",
    title: "Jenga Realty AI",
    subtitle: "Multimodal B2B Property Acquisition & Advisory",
    category: "AI Integration Showcase",
    problem: "Real estate transactions in East Africa suffer from high friction, lack of centralized verified data, and slow cross-border mortgage approvals for the diaspora community looking to invest back home.",
    solution: "Jibu Labs engineered a custom AI suite including conversational mortgage advisors, computer vision property analysis pipelines, and semantic vector search engines to surface neighborhood development trends directly on-device.",
    tech: ["Llama 3 (Fine-tuned)", "Pinecone Vector DB", "Kotlin Multiplatform", "Jetpack Compose", "TensorFlow Lite"],
    impact: "40% reduction in diaspora mortgage onboarding time, 85% automated image moderation, and 2.1x faster transaction processing velocity.",
    metrics: [
      { label: "Onboarding Time", value: "-40%" },
      { label: "Image Moderation", value: "85% Auto" },
      { label: "Transaction Speed", value: "2.1x Faster" }
    ],
    image: JengaMockup1,
    imageAlt: JengaMockup2
  },
  {
    id: "budgeting-buddy",
    title: "Budgeting Buddy",
    subtitle: "Intelligent SMB Expense Automation & Forecasting",
    category: "Process Automation",
    problem: "Small businesses waste hundreds of hours manually categorizing receipts, tracking expenditures, and attempting to forecast seasonal cash flow dips with spreadsheets.",
    solution: "An agentic finance assistant that integrates with banking APIs to auto-categorize receipts using OCR and fine-tuned NLP models, while generating cash flow forecasts using natural conversational interface endpoints.",
    tech: ["OpenAI GPT-4 API", "Python / FastAPI", "PostgreSQL", "React", "Tesseract OCR"],
    impact: "Saves average business owners 12 hours/week in bookkeeping, delivers 98% accuracy in tax-deductible sorting, and predicts cash flow crunches with 92% confidence.",
    metrics: [
      { label: "Bookkeeping Saved", value: "12h/wk" },
      { label: "Sorting Accuracy", value: "98%" },
      { label: "Forecast Confidence", value: "92%" }
    ],
    image: mobilePlaceholder
  },
  {
    id: "road-black-spot",
    title: "Road Black Spot",
    subtitle: "Computer Vision Safety Modeling & Analytics",
    category: "Edge AI & Computer Vision",
    problem: "Municipal traffic management lacks real-time predictive hazard analysis, leading to high accident rates at unmonitored road intersections (black spots).",
    solution: "Deployed computer vision models on edge camera nodes to detect near-miss collisions, log traffic anomalies, and feed predictive models that alert local authorities of potential incident hotspots before they occur.",
    tech: ["YOLOv8", "Nvidia Jetson Edge Nodes", "Python", "MQTT / WebSockets", "TailwindCSS Dashboard"],
    impact: "Reduces traffic incident response times by 35%, detects 94% of near-miss events, and assists cities in prioritizing road infrastructure safety improvements.",
    metrics: [
      { label: "Response Latency", value: "-35%" },
      { label: "Near-Miss Detection", value: "94%" },
      { label: "City Safety Index", value: "+45%" }
    ],
    image: mobilePlaceholder
  },
  {
    id: "hadithi-project",
    title: "Hadithi Project",
    subtitle: "Generative Storytelling & Cultural Preservation",
    category: "Multimodal Creative GenAI",
    problem: "Traditional folklore and regional languages are rapidly declining, with a lack of localized, interactive educational content to engage younger generations.",
    solution: "A conversational storytelling engine that translates written or spoken local dialect inputs into rich illustrated stories, using generative image diffusion models and custom text-to-speech dialect maps.",
    tech: ["Stable Diffusion XL", "ElevenLabs Voice API", "Node.js", "React Native", "MongoDB"],
    impact: "Over 50,000 active monthly learners, 20+ regional dialects preserved, and featured in educational research journals for literacy enhancement.",
    metrics: [
      { label: "Active Learners", value: "50K+" },
      { label: "Dialects Saved", value: "20+" },
      { label: "Literacy Score", value: "+30%" }
    ],
    image: mobilePlaceholder
  }
];
